import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';
import { z } from 'zod';

export const onboardingCreatePharmacyRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  validateSearch: z.object({
    phoneNumber: z.string().optional(),
  }),
  path: '/create_pharmacy',
}).lazy(() =>
  import('pages/shared/Onboarding/CreatePharmacy/CreatePharmacyPage').then((d) => d.Route)
);
